import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SortOrder } from '../../sort-order.enum';

@Component({
  selector: 'cc-users-table-header',
  templateUrl: './users-table-header.component.html',
  styleUrls: ['./users-table-header.component.scss'],
})
export class UsersTableHeaderComponent {
  @Input() tableHeaders = [];
  @Input() showCheckbox = false;
  @Output() checkAll: EventEmitter<void> = new EventEmitter();
  @Input() isChecked: boolean;
  @Output() sort: EventEmitter<string> = new EventEmitter();
  @Input() sortingColumn: string;
  @Input() currentSortOrder: SortOrder = SortOrder.ASC;
  @Input() tableName: string;
  @Input() enableSorting?: boolean;
  @Input() showPermissionHeader: boolean;

  constructor() {}

  onCheckAll() {
    this.checkAll.emit();
  }

  onSort(columnName: string) {
    if (this.enableSorting) {
      this.sort.emit(columnName);
    }
  }
}
